import React from 'react';
import Modal from '../commons/Modal';

const ErrorPopup = ({
  isOpen,
  onClose,
  title,
  description,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        isClosable={false}
        onClose={onClose}
        Content={(
          <>
            <p className='payment-fail-title'>
              {title}
            </p>
            <span className='payment-fail-description'>
              {description}
            </span>
            <button className='basic-button h-40 fs-13 mt-20 mb-2' onClick={onClose}>
              확인
            </button>
          </>
        )}
      />
    </>
  );
};

export default ErrorPopup;